export default __webpack_public_path__ + "static/media/third-step-select-tooltip-image.1692acb3.jpg";